/**
 * Normalize a raw section string to a canonical form (trim + lowercase).
 *
 * Used at line-item / add-on insertion time to populate `section_normalized`
 * so the back-solver and section-based bases can bucket items consistently.
 *
 * No alias expansion is done here — the LLM emits structured basisRef
 * objects that reference line items by ID, and the resolver translates
 * those to sections via the line item's normalized value. There is no
 * fuzzy-string-matching layer in the import pipeline.
 */
export function normalizeSection(raw: string | null): string | null {
  if (raw == null) return null;
  const trimmed = raw.trim().toLowerCase();
  return trimmed.length === 0 ? null : trimmed;
}
